import { Image } from "antd";
import { useState } from "react";
import { useParams } from "react-router-dom";

import {
  LoginForm,
  RegisterForm,
  ForgotPasswordForm,
  VerificationForm,
} from "../components/Auth";
import authImage from "../assets/images/auth-image.jpg";
import { withNamespaces } from "react-i18next";
import { useMediaQuery } from "react-responsive";


const Auth = ({ t }) => {
  const params = useParams();
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const [formType, setFormType] = useState(params["*"] ? params["*"] : "login");
  const [registerType, setRegisterType] = useState("client");

  const formSwitcher = () => {
    switch (formType) {
      case "login":
        return {
          title: t("pages.auth.loginToNameText"),
          form: <LoginForm setFormType={setFormType} />,
        };
      case "register":
        return {
          title: t("pages.auth.registerToNameText"),
          form: (
            <RegisterForm
              setFormType={setFormType}
              registerType={registerType}
            />
          ),
        };
      case "forgot-passowrd":
        return {
          title: t("pages.auth.forgotPassword"),
          form: <ForgotPasswordForm setFormType={setFormType} />,
        };
      case "verification":
        return {
          title: "Check your phone",
          form: <VerificationForm setFormType={setFormType} />,
        };
      default:
        return <LoginForm setFormType={setFormType} />;
    }
  };

  return (
    <section style={{ display: "flex", flexDirection: "row", height: "100vh" }}>
      {!isMobile && (
        <div style={{ height: "100%", width: "60%" }}>
          <Image
            width="100%"
            height="100%"
            style={{ objectFit: "cover" }}
            src={authImage}
            preview={false}
          />
        </div>
      )}
      <div className="auth-container" style={{ width: isMobile ? "100%" : "40%" }}>
        <div
          className="auth-container__form"
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
            overflowX: "auto",
            padding: "2rem 0",
          }}
        >
          <div style={{ width: "70%" }}>
            {formType === "login" || formType === "register" ? (
              <p
                style={{
                  fontStyle: "normal",
                  fontWeight: "400",
                  fontSize: "16px",
                  lineHeight: "20px",
                }}
              >
                {t("pages.auth.welcomeBack")}
              </p>
            ) : null}
            <h1
              style={{
                fontStyle: "normal",
                fontWeight: "500",
                fontSize: "20px",
                lineHeight: "29px",
                textAlign: "center",
              }}
            >
              {formSwitcher().title}
            </h1>

            {formType === "register" ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                  height: "2.8rem",
                  margin: "1.6rem 0",
                  borderRadius: "5px",
                  border: "1px solid #E8E8E8",
                  cursor: "pointer",
                }}
              >
                <div
                  style={{
                    width: "50%",
                    height: "100%",
                    backgroundColor:
                      registerType === "client" ? "#012F6B" : "#FFFFFF",
                    color: registerType === "client" ? "#FFFFFF" : "#012F6B",
                    fontSize: "14px",
                    lineHeight: "24px",
                    fontWeight: "500",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: "5px",
                  }}
                  onClick={() => setRegisterType("client")}
                >
                  {t("pages.auth.client")}
                </div>
                <div
                  style={{
                    width: "50%",
                    height: "100%",
                    backgroundColor:
                      registerType === "client" ? "#FFFFFF" : "#012F6B",
                    color: registerType === "client" ? "#012F6B" : "#FFFFFF",
                    fontSize: "14px",
                    lineHeight: "24px",
                    fontWeight: "500",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: "5px",
                  }}
                  onClick={() => setRegisterType("translator")}
                >
                  {t("pages.auth.translator")}
                </div>
              </div>
            ) : null}
          </div>
          {formSwitcher().form}
        </div>
      </div>
    </section>
  );
};

export default withNamespaces()(Auth);
